import ReactDOM from 'react-dom';
import Routes from './router';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import './assets/js/gt';
import './global.less';
moment.locale('zh-cn');

ReactDOM.render(
  <ConfigProvider locale={zhCN}>
    <Routes />
  </ConfigProvider>,
  document.getElementById('root')
);
